import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Text,
  VStack,
  Icon,
} from '@chakra-ui/react';
import { AlertCircle, CheckCircle } from 'lucide-react';
import { useModalStyles } from '../../../../utils/modal.styles';

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  icon?: 'warning' | 'success';
}

export function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  icon = 'success',
}: ConfirmModalProps) {
  const styles = useModalStyles();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay bg={styles.modal.overlayBg} />
      <ModalContent bg={styles.modal.bg} borderColor={styles.section.borderColor} borderWidth="1px">
        <ModalHeader color={styles.text.primary}>{title}</ModalHeader>
        <ModalCloseButton color={styles.icon.default} />
        <ModalBody py={6}>
          <VStack spacing={4} textAlign="center">
            <Icon
              as={icon === 'success' ? CheckCircle : AlertCircle}
              w={12}
              h={12}
              color={icon === 'success' ? 'green.500' : 'orange.500'}
            />
            <Text color={styles.text.muted}>{message}</Text>
          </VStack>
        </ModalBody>
        <ModalFooter bg={styles.footer.bg} borderTopWidth="1px" borderColor={styles.footer.borderColor}>
          <Button
            variant="ghost"
            mr={3}
            onClick={onClose}
            {...styles.button.ghost}
            color={styles.text.muted}
          >
            {cancelText}
          </Button>
          <Button
            colorScheme={icon === 'success' ? 'blue' : 'orange'}
            onClick={handleConfirm}
            bgGradient={icon === 'success' ? styles.button.primary.bgGradient : undefined}
            _hover={icon === 'success' ? styles.button.primary._hover : undefined}
          >
            {confirmText}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

